export default __webpack_public_path__ + "static/media/49t.98b4b1f8.jpg";